
import React from 'react';

function Music() {
  return (
    <div>
      <h1>Music Page</h1>
    </div>
  );
}

export default Music;
